import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as i, unref as a, renderSlot as u, createElementVNode as n, createCommentVNode as v } from "vue";
import { useScalarIcon as H } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, m = { key: 1 }, f = { key: 2 }, h = { key: 3 }, k = { key: 4 }, M = { key: 5 }, Z = {
  name: "ScalarIconTextH"
}, _ = /* @__PURE__ */ p({
  ...Z,
  props: {
    label: {},
    weight: {}
  },
  setup(V) {
    const r = V, { bind: s, weight: l } = H(r);
    return (d, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(s)), [
      u(d.$slots, "default"),
      a(l) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        n("path", { d: "M212,56V200a12,12,0,0,1-24,0V140H68v60a12,12,0,0,1-24,0V56a12,12,0,0,1,24,0v60H188V56a12,12,0,0,1,24,0Z" }, null, -1)
      ]))) : a(l) === "duotone" ? (o(), e("g", m, t[1] || (t[1] = [
        n("path", {
          d: "M200,56V200H56V56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : a(l) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,176a8,8,0,0,1-16,0V136H88v40a8,8,0,0,1-16,0V80a8,8,0,0,1,16,0v40h80V80a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : a(l) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        n("path", { d: "M206,56V200a6,6,0,0,1-12,0V134H62v66a6,6,0,0,1-12,0V56a6,6,0,0,1,12,0v66H194V56a6,6,0,0,1,12,0Z" }, null, -1)
      ]))) : a(l) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        n("path", { d: "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : a(l) === "thin" ? (o(), e("g", M, t[5] || (t[5] = [
        n("path", { d: "M204,56V200a4,4,0,0,1-8,0V132H60v68a4,4,0,0,1-8,0V56a4,4,0,0,1,8,0v68H196V56a4,4,0,0,1,8,0Z" }, null, -1)
      ]))) : v("", !0)
    ], 16));
  }
});
export {
  _ as default
};
